<div #modal [class.platform-link-copy-confirmation]="platformLinkToShow" [id]="modalable.getModalId()"
     class="modal"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">

                <button (click)="onModalClose()" class="close-button float-end" data-bs-dismiss="modal" title="Schließen"
                        type="button">
                    <i aria-hidden="true" class="fa fa-times"></i>
                </button>

                @if (platformLinkToShow) {
                    <app-platform-link-copied-confirmation
                            [platform]="platformLinkToShow"></app-platform-link-copied-confirmation>
                }

                @if (!platformLinkToShow) {
                    <h2>Abgabelink für Schülerinnen und Schüler</h2>
                    <h1>{{ modalable.title }}</h1>
                    <a [href]="downloadLink" class="download-link" target="_blank"><i class="fas fa-analytics"></i>
                        Auswertung öffnen</a>
                    <div class="homework-sharing-container">
                        @if (modalable.domain && modalable.link) {
                            <div class="homework-qr d-flex align-items-center justify-content-center"
                                 title="Der Link zur Aufgabe als QR-Code">
                                @if (isSvg(modalable.qrCode)) {
                                    <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(modalable.qrCode)" style="width: 100%; height: 100%;"></div>
                                }
                                @if (!isSvg(modalable.qrCode)) {
                                    <img [src]="modalable.qrCode" alt="Link zur Aufgabe" style="max-width: 100%; height: auto;"/>
                                }
                            </div>
                        }
                        <div class="sharing-options">
                            <app-sharing-options (platformLinkCopied)="onOpenPlatformLinkModal($event)"
                                                 [sharingContext]="{homework: modalable}" [homeworkModalId]="modalable.getModalId()"></app-sharing-options>
                        </div>
                    </div>
                    <a [attr.href]="link" class="homework-link" target="_blank">
                        {{ modalable.domain }}/{{ modalable.link }}
                    </a>
                    <div class="modal-buttons">
                        <a [href]="modalable.printLink" class="print-button" target="_blank"><i
                                class="fas fa-print"></i> Druckansicht öffnen</a>
                        @if (applicationStateService.userData.isTeacher && applicationStateService.bookConfig.hasCalcuflowAe) {
                            <button (click)="openWorksheetEditor()"
                               class="btn btn-round btn-semibold btn-blue"
                            >
                                <img [src]="'sidebar/sidebar-icon-calcuflow.png' | asset"> im Arbeitsblatt-Editor öffnen
                            </button>
                        }
                    </div>
                }
            </div>
            <div [class.platform]="platformLinkToShow" class="modal-footer justify-content-center">
                @if (!platformLinkToShow) {
                    <div>
                        <i class="fas fa-link"></i><span>Einfach Link öffnen und {{ 'hsm.homeworks' | translation : applicationStateService.bookConfig.publisherText }}
                        lösen!</span>
                    </div>
                    <div>
                        <i class="fas fa-analytics"></i><span>Auswertungen werden auch an deine angegebene E-Mail gesendet.</span>
                    </div>
                }
                @if (platformLinkToShow) {
                    <button (click)="onModalClose()" class="close-platform-link-btn" data-bs-dismiss="modal">
                        Info schließen
                    </button>
                }
            </div>
        </div>
    </div>
</div>
